<div class="modal fade create-album-modal" id="create-album-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': universalService.showCreateAlbumModal ? 'block' : 'none','opacity': 1,'transition':'all ease-in .1s'}" (keydown.esc)="escKeyPressHandle($event);">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <!-- Close Icon -->
    <div class="modal-content h-90">
      <div class="modal-header">
        @if(!listService.createAlbumObject){
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closeCreateAlbumModal();AlbumName.value=''">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }@else{
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="goBackToPreviousScreen();AlbumName.value=''">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
      </div>
      <div class="modal-body">
        <div class="create-folder-main">
          <h2 class="title mb-5">Create new Album </h2>
          <form onsubmit="return false">
            <input #AlbumName type="text" maxlength="50" autocomplete="off" id="AlbumName" (keyup)="validateBeforeCreatingAlbum(AlbumName)" placeholder="Add a title" autofocus/>
            <button class="btn mt-3 mb-2  ripple-fx" title="Create new Album" [disabled]="!enableButton" (click)="createAlbumAndAdd(AlbumName)">{{buttonText}}</button>
            @if (universalService.selectedTab != 'Albums' && listService.createAlbumObject) {
              <span class="text-center btn-go-back mt-5 d-none d-lg-block" title="Go Back" data-dismiss="modal" (click)="goBackToPreviousScreen();AlbumName.value=''"><a href="javascript:void()" rel="noopener noreferrer">Go Back</a></span>
            }
          </form>
        </div>
      </div>
      <div class="modal-footer border-top-0">&nbsp;</div>
    </div>
  </div>


</div>